import React from 'react';
import { Star } from 'lucide-react';
export function SocialProofSeal() {
  return <div className="bg-[#2D5016] text-white py-4" data-id="element-331">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-4 text-center" data-id="element-332">
        <div className="flex items-center gap-1" data-id="element-333">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" data-id="element-334" />)}
        </div>
        <p className="font-medium text-lg" data-id="element-335">
          <span className="font-bold" data-id="element-336">Valorado 4.8/5</span> por más de{' '}
          <span className="font-bold text-[#D4AF37]" data-id="element-337">10.000 mujeres</span> en
          España
        </p>
      </div>
    </div>;
}